module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1744893076018-6/BJ03.mp4.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n    你的浏览器不支持视频播放。\n")]), _vm._v(" "), _c('div', {
    staticClass: "photo-frame"
  }, [_c('img', {
    attrs: {
      "src": _vm.start.heying,
      "alt": "Team Photo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "team-name"
  }, [_vm._v(_vm._s(_vm.start.mingcheng))]), _vm._v(" "), _c('div', {
    staticClass: "slogan"
  }, [_vm._v(_vm._s(_vm.start.kouhao))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b5fb70d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreStartArmyPro.vue
// module id = 2330
// module chunks = 0